import {
  useDismiss,
  useInteractions as useInteractionsBase,
  useListNavigation,
  useRole,
  useTypeahead,
} from "@floating-ui/react";
import { Props } from "./UseInteractions.Parts";

export const useInteractions = ({
  anchor,
  floatingContext,
  toastContainerRef,
  activeIndex,
  setActiveIndex,
  listRef,
  labelsRef,
  disabledIndices,
}: Props) => {
  const interactions = useInteractionsBase([
    useListNavigation(floatingContext, {
      listRef,
      activeIndex,
      onNavigate: setActiveIndex,
      focusItemOnOpen: "auto",
      disabledIndices,
    }),
    useTypeahead(floatingContext, {
      listRef: labelsRef,
      activeIndex,
      onMatch: setActiveIndex,
    }),
    useDismiss(floatingContext, {
      outsidePress: (event) => {
        // Prevent closing if the click is on the NavBar (the anchor)
        if (anchor?.contains(event.target as Node)) return false;

        // Don't close if click is inside the toast container
        if (
          toastContainerRef &&
          toastContainerRef.current &&
          toastContainerRef.current.contains(event.target as Node)
        )
          return false;

        return true;
      },
    }),
    useRole(floatingContext, { role: "listbox" }),
  ]);

  return interactions;
};
